var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.alert)?_c('div',{staticClass:"form-builder-alert"},[_c('v-alert',{attrs:{"type":"error"}},[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }